import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { SharedCommonModule } from './shared/shared-common.module';
import { LayoutModule } from './layout/layout.module';
import { StoreModule } from './store/store.module';
import { FormsModule } from '@angular/forms';
import { DefaultHeadersInterceptor } from './shared/interceptor/default-headers.interceptor';
import { LoaderInterceptor } from './shared/interceptor/loading-bar.interceptor';
import { NzLayoutModule } from 'ng-zorro-antd';
import { HomeComponent } from './pages/home/home.component';
import { LoginModule } from './pages/login/login.module';
import { NotificationModule } from './shared/notification/notification.module';
import { SignupModule } from './pages/signup/signup.module';
import { RouteComponent } from './pages/route/route.component';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { ResultModule } from './pages/result/result.module';
import { NgOtpInputModule } from 'ng-otp-input';
import { PhoneLoginModule } from './pages/phone-login/phone-login.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PaymentModule } from './pages/payment/payment.module';
import { HttpCancelInterceptor } from './shared/interceptor/http-cancel.interceptor';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    RouteComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    SharedCommonModule,
    LayoutModule,
    StoreModule,
    PhoneLoginModule,
    NzLayoutModule,
    LoginModule,
    PaymentModule,
    NotificationModule,
    SignupModule,
    ResultModule,
    MatInputModule,
    MatIconModule,
    NgOtpInputModule,
    NgbModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DefaultHeadersInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpCancelInterceptor,
      multi: true,
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {
}
